import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { LocationObject } from '../../../../types/location-object';

type CellParams = ICellRendererParams<LocationObject<'Terminal'>> & {
  deleteCallback: (item: LocationObject<'Terminal'>) => void;
};

@Component({
  selector: 'app-pan-cell-location-edit-terminal-actions',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './cell-location-edit-terminal-actions.component.html',
  styleUrl: './cell-location-edit-terminal-actions.component.scss',
})
export class CellLocationEditTerminalActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
